const WHEEL_LINE_PIXELS = 24;
const WHEEL_PAGE_RATIO = 0.9;
export const WHEEL_DELTA_PIXEL = 0;
export const WHEEL_DELTA_LINE = 1;
export const WHEEL_DELTA_PAGE = 2;

export interface HorizontalWheelInput {
  current: number;
  maximum: number;
  clientWidth: number;
  deltaX: number;
  deltaY: number;
  deltaMode: number;
  modified: boolean;
}

function wheelDistance(
  delta: number,
  deltaMode: number,
  clientWidth: number,
): number {
  if (deltaMode === WHEEL_DELTA_LINE) {
    return delta * WHEEL_LINE_PIXELS;
  }
  if (deltaMode === WHEEL_DELTA_PAGE) {
    return delta * clientWidth * WHEEL_PAGE_RATIO;
  }
  return delta;
}

export function horizontalWheelTarget({
  current,
  maximum,
  clientWidth,
  deltaX,
  deltaY,
  deltaMode,
  modified,
}: HorizontalWheelInput): number | null {
  if (
    modified ||
    maximum <= 0 ||
    deltaY === 0 ||
    Math.abs(deltaX) >= Math.abs(deltaY)
  ) {
    return null;
  }

  const distance = wheelDistance(deltaY, deltaMode, clientWidth);
  const target = Math.min(maximum, Math.max(0, current + distance));
  return target === current ? null : target;
}

export function enableHorizontalWheelScroll(element: HTMLElement): () => void {
  const onWheel = (event: WheelEvent): void => {
    const target = horizontalWheelTarget({
      current: element.scrollLeft,
      maximum: element.scrollWidth - element.clientWidth,
      clientWidth: element.clientWidth,
      deltaX: event.deltaX,
      deltaY: event.deltaY,
      deltaMode: event.deltaMode,
      modified: event.ctrlKey || event.metaKey,
    });
    if (target === null) {
      return;
    }
    element.scrollLeft = target;
    event.preventDefault();
  };

  element.addEventListener("wheel", onWheel, { passive: false });
  return () => element.removeEventListener("wheel", onWheel);
}
